import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import WithBarberShortName from '../hoc/WithBarberShortName';
import WithServiceName from '../hoc/WithServiceName';
import WithReservationTime from '../hoc/WithReservationTime';
import Step from './Step';
import { stepsShape } from '../shapes';
import { generateSteps } from '../utils/steps';
import { STEPS } from '../constants';


const Steps = ({ steps }) => {
  const className = 'u-hide-for-medium-and-down';

  return (
    <div className="c-steps">
      <ul className="c-breadcrumbs">
        { steps.map(
          (step, i) => <Step step={step} className={i > 0 ? className : ''} trim={step.key} key={step.key} />
        )}
      </ul>
    </div>
  );
};
Steps.propTypes = {
  steps: stepsShape.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const textValues = {
    [STEPS.barber]: ownProps.barberName,
    [STEPS.service]: ownProps.serviceName,
    [STEPS.time]: ownProps.reservationTime,
  };

  return {
    steps: generateSteps(textValues, ownProps.params, ownProps.urlPattern),
    textValues,
  };
};

export default compose(
  WithBarberShortName,
  WithServiceName,
  WithReservationTime,
  connect(mapStateToProps),
)(Steps);



// WEBPACK FOOTER //
// ./src/app/components/Steps.jsx